module.exports = function _isString(x) {
  return Object.prototype.toString.call(x) === '[object String]';
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/ramda/src/internal/_isString.js
// module id = 209
// module chunks = 0